<div class="dash">
    <app-tabs [tabs]="tabs" (onChangeTab)="onChangeTab($event)"
        [currentTab]="tabIndex" [dashboardTab]="true">
    </app-tabs>
    <app-spacer [bottom]="16"></app-spacer>

    <div class="dash-card no-padding">
        <div class="dash-card-header d-block" style="flex-direction: column;">
            <div class="row no-gutters">
                <div class="col-12">
                    <h2>Variáveis</h2>
                </div>
            </div>

            <div class="row no-gutters">
                <div class="col-12 d-flex justify-content-end mt-3 px-0">
                    <ng-container *ngIf="loading">
                        <ngx-skeleton-loader [theme]="{
                            width: '120px',
                            height: '40px',
                            marginRight: '8px'
                          }">
                        </ngx-skeleton-loader>
                        <ngx-skeleton-loader [theme]="{
                            width: '120px',
                            height: '40px',
                            marginRight: '8px'
                          }">
                        </ngx-skeleton-loader>
                        <ngx-skeleton-loader [theme]="{
                            width: '180px',
                            height: '40px'
                          }">
                        </ngx-skeleton-loader>
                    </ng-container>

                    <ng-container *ngIf="!loading">
                        <app-button
                            *ngIf="hasFilters && permissionObj.canFilter"
                            [danger]="true" [outline]="true" class="mr-2"
                            (onClick)="resetForm()">
                            <svg-icon src="assets/images/icon-times.svg"
                                class="filter-clear-icon"></svg-icon>
                            Limpar filtros
                        </app-button>

                        <app-button [inverted]="true" class="add-button mr-2"
                            (onClick)="toggleFilterModal()"
                            *ngIf="permissionObj.canFilter">
                            <svg-icon src="assets/images/icon_filter.svg"
                                class="mr-2"></svg-icon>
                            {{ hasFilters ? 'Editar filtros' : 'Filtrar
                            listagem' }}
                        </app-button>

                        <app-button (onClick)="exampleModal = true"
                            class="add-button" *ngIf="permissionObj.canEdit">
                            <svg-icon src="assets/images/icon-eye.svg"
                                class="mr-2 mt-1 mb-1"></svg-icon>
                            Ver modelo de exemplo
                        </app-button>
                    </ng-container>
                </div>
            </div>

            <div class="col-12 mt-3 px-0"
                *ngIf="!loading && hasFilters && appliedFilters.length > 0">
                <div
                    class="d-flex flex-wrap align-items-center justify-content-end">
                    <app-filter-tag *ngFor="let filter of appliedFilters"
                        [label]="filter.label" [value]="filter.value">
                    </app-filter-tag>
                </div>
            </div>
        </div>

        <div class="dash-card-body padding-container">
            <ng-container *ngIf="loading">
                <table #table>
                    <thead>
                        <tr>
                            <th>
                                <ngx-skeleton-loader [theme]="{
                                        height: '15px',
                                        width: '125px',
                                        marginBottom:'0'
                                      }">
                                </ngx-skeleton-loader>
                            </th>

                            <th class="text-right">
                                <ngx-skeleton-loader [theme]="{
                                        height: '15px',
                                        width: '125px',
                                        marginBottom:'0'
                                      }">
                                </ngx-skeleton-loader>
                            </th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let number of [0,1,2,3,4,5,6]">
                            <td>
                                <ngx-skeleton-loader [theme]="{
                                            height: '15px',
                                            width: '100px',
                                        marginBottom:'0'
                                          }">
                                </ngx-skeleton-loader>
                            </td>
                            <td class="item-number">
                                <ngx-skeleton-loader [theme]="{
                                        height: '15px',
                                        width: '30px',
                                        marginBottom:'0'
                                      }">
                                </ngx-skeleton-loader>
                            </td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </ng-container>

            <table class="bordered"
                *ngIf="!loading && data.length > 0 && activedTab === 'cadastro'">
                <thead>
                    <tr>
                        <th>Termo</th>
                        <th>Descrição</th>
                        <th>Variável</th>
                        <th>Status</th>
                        <th></th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let item of data">
                        <td>{{item.name}}</td>

                        <td>
                            {{item.description}}
                        </td>

                        <td>
                            <div class="tag">
                                {{item.variable}}
                            </div>
                        </td>

                        <td>
                            <div class="status-tag"
                                [class.-inactive]="!item.status">
                                {{item.status ? 'Ativo' : 'Inativo'}}
                            </div>
                        </td>

                        <td>
                            <div class="dash-card-item-buttons">
                                <app-tooltip text="Inativar" [position]="'top'"
                                    *ngIf="permissionObj.canChange && item.status">
                                    <button class="dash-item-button"
                                        (click)="handleToggleStatus(item.id)">
                                        <svg-icon
                                            src="assets/images/icon-ban.svg"></svg-icon>
                                    </button>
                                </app-tooltip>
                                <app-tooltip text="Inativar" [position]="'top'"
                                    *ngIf="permissionObj.canChange && !item.status">
                                    <button class="dash-item-button"
                                        (click)="handleToggleStatus(item.id)">
                                        <svg-icon
                                            src="assets/images/icon-check.svg"></svg-icon>
                                    </button>
                                </app-tooltip>
                            </div>
                        </td>
                    </tr>


                </tbody>
                <app-spacer [bottom]="28"></app-spacer>
            </table>

            <table class="bordered"
                *ngIf="!loading && fsData.length > 0 && activedTab === 'fundo'">
                <thead>
                    <tr>
                        <th>Termo</th>
                        <th>Descrição</th>
                        <th>Header</th>
                        <th>Status</th>
                        <th></th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let item of fsData">
                        <td>{{item.name}}</td>

                        <td>
                            {{item.description}}
                        </td>

                        <td>
                            <div class="tag smart">
                                {{item.variable}}
                            </div>
                        </td>

                        <td>
                            <div class="status-tag"
                                [class.-inactive]="!item.status">
                                {{item.status ? 'Ativo' : 'Inativo'}}
                            </div>
                        </td>

                        <td>
                            <div class="dash-card-item-buttons">
                                <app-tooltip text="Inativar" [position]="'top'"
                                    *ngIf="permissionObj.canChange && item.status">
                                    <button class="dash-item-button"
                                        (click)="handleToggleStatus(item.id)">
                                        <svg-icon
                                            src="assets/images/icon-ban.svg"></svg-icon>
                                    </button>
                                </app-tooltip>
                                <app-tooltip text="Inativar" [position]="'top'"
                                    *ngIf="permissionObj.canChange && !item.status">
                                    <button class="dash-item-button"
                                        (click)="handleToggleStatus(item.id)">
                                        <svg-icon
                                            src="assets/images/icon-check.svg"></svg-icon>
                                    </button>
                                </app-tooltip>
                            </div>
                        </td>
                    </tr>

                </tbody>
                <app-spacer [bottom]="28"></app-spacer>
            </table>

            <ng-container
                *ngIf="!loading && !hasFilters && ((activedTab === 'cadastro' && data.length === 0) || (activedTab === 'fundo' && fsData.length === 0))">
                <app-empty-content [isVisible]="true" [large]="true"
                    title="Não há nenhuma variável para exibir"
                    description="Não há Variáveis de minutas para serem exibidas no momento."
                    icon="/assets/images/figure_3d_search.png">
                </app-empty-content>
            </ng-container>

            <ng-container
                *ngIf="!loading && hasFilters && ((activedTab === 'cadastro' && data.length === 0) || (activedTab === 'fundo' && fsData.length === 0))">
                <app-empty-content [isVisible]="true" [large]="true"
                    title="Nenhum resultado encontrado"
                    description="Não foram encontradas variáveis com os filtros aplicados. Tente ajustar os filtros para ver mais resultados."
                    icon="/assets/images/figure_3d_search.png">
                </app-empty-content>
            </ng-container>
        </div>
    </div>
</div>

<div class="col-12 ml-auto mr-auto" [class.d-none]="activedTab !== 'cadastro'"
    *ngIf="!loading && data.length > 0">
    <div class="dash-card-pagination">
        <app-pagination [data]="data" [count]="count" [show]="!loading"
            [offset]="offset" (onPageChange)="changePageData('cadastro',$event)"
            [dashPagination]="true" [resultsPerPage]="resultsPerPage">
        </app-pagination>
    </div>
</div>

<div class="col-12 ml-auto mr-auto" [class.d-none]="activedTab !== 'fundo'"
    *ngIf="!loading && fsData.length > 0">
    <div class="dash-card-pagination">
        <app-pagination [data]="fsData" [count]="fsCount" [show]="!loading"
            [offset]="fsOffset" (onPageChange)="changePageData('fundo',$event)"
            [dashPagination]="true" [resultsPerPage]="fsResultsPerPage">
        </app-pagination>
    </div>
</div>

<app-carbon-warning-modal [active]="warningModal" [customContent]="true"
    size="large" title="Inativar variável" confirmText="Inativar variável"
    cancelText="Cancelar" [loading]="loading"
    loadingConfirmText="Inativando..."
    [skipAutoCloseOnConfirm]="true"
    [confirmAction]="confirmInactivateVariable.bind(this)"
    [cancelAction]="closeWarningModal.bind(this)"
    (onClose)="closeWarningModal()">
    <p *ngIf="!modelsLoading && models.length > 0">
        Os modelos de minuta abaixo possuem a variável selecionada em
        seu conteúdo. Deseja realmente inativar a variável
        <strong>[{{variableLabel}}]</strong>?
    </p>
    <p *ngIf="!modelsLoading && models.length === 0">
        Deseja realmente inativar a variável
        <strong>[{{variableLabel}}]</strong>?
    </p>

    <ng-container *ngIf="modelsLoading">
        <table>
            <thead>
                <tr>
                    <th>
                        <ngx-skeleton-loader [theme]="{
                                        height: '15px',
                                        width: '125px',
                                        marginBottom:'0'
                                      }">
                        </ngx-skeleton-loader>
                    </th>

                    <th>
                        <ngx-skeleton-loader [theme]="{
                                        height: '15px',
                                        width: '125px',
                                        marginBottom:'0'
                                      }">
                        </ngx-skeleton-loader>
                    </th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let number of [0,1,2,3]">
                    <td>
                        <ngx-skeleton-loader [theme]="{
                                            height: '15px',
                                            width: '100px',
                                        marginBottom:'0'
                                          }">
                        </ngx-skeleton-loader>
                    </td>
                    <td>
                        <ngx-skeleton-loader [theme]="{
                                        height: '15px',
                                        width: '300px',
                                        marginBottom:'0'
                                      }">
                        </ngx-skeleton-loader>
                    </td>
                    <td></td>
                </tr>
            </tbody>
        </table>
    </ng-container>

    <ng-container *ngIf="!modelsLoading && models.length > 0 ">
        <div class="models-table-scroll">
            <table class="bordered">
                <thead>
                    <tr>
                        <th>Nome do modelo</th>
                        <th>Fundo vinculado</th>
                        <th></th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let item of models">
                        <td>{{item.document_name}}</td>

                        <td>
                            {{joinFunds(item.funds)}}
                        </td>

                        <td>
                            <app-tooltip text="Visualizar" position="top"
                                *ngIf="canViewDraft">
                                <button class="text-right"
                                    (click)="redirectToModel(item.document_id)">
                                    <svg-icon
                                        src="assets/images/icon-eye.svg"></svg-icon>
                                </button>
                            </app-tooltip>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="dash-card-pagination">
            <app-pagination [data]="models" [count]="modelsCount"
                [show]="!loading" [offset]="modelsOffset"
                (onPageChange)="changeModelsPageData($event)"
                [dashPagination]="true" [resultsPerPage]="modelsResultsPerPage">
            </app-pagination>
        </div>
    </ng-container>
</app-carbon-warning-modal>

<app-warning-modal [active]="exampleModal" (onClose)="closeWarningModal()"
    size="lg">
    <h3>Modelo de exemplo do uso de variáveis</h3>
    <app-spacer [bottom]="24"></app-spacer>

    <p>
        Digite ou clique nas variáveis para editar o texto.
    </p>
    <app-spacer [bottom]="16"></app-spacer>

    <div class="variables-list">
        <h4>Variáveis disponíveis:</h4>
        <app-spacer [bottom]="12"></app-spacer>
        <div class="variables-container">
            <div *ngFor="let variable of exempleVariables" class="variable-item"
                (click)="insertVariable(variable.label)">
                <div class="tag" [class.smart]="variable.type === 'fs_engine'">
                    {{variable.label}}
                </div>
                <small>{{variable.value}}</small>
            </div>
        </div>
    </div>
    <app-spacer [bottom]="24"></app-spacer>

    <form [formGroup]="exempleForm">
        <quill-editor [modules]="quillModules" class="editor-container"
            formControlName="content">
        </quill-editor>
    </form>
</app-warning-modal>

<app-side-modal [active]="showFilterModal" title="Filtrar listagem"
    (onClose)="toggleFilterModal()">
    <form [formGroup]="filterForm" *ngIf="activedTab === 'cadastro'">
        <div class="row">
            <div class="col-12">
                <app-input [group]="filterForm" controlName="search"
                    placeholder="Digite" label="Nome">
                </app-input>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12">
                <app-select [items]="statusOptions" [group]="filterForm"
                    controlName="status" placeholder="Selecione" label="Status">
                </app-select>
                <app-spacer [bottom]="16"></app-spacer>
            </div>


        </div>
        <app-spacer [bottom]="32"></app-spacer>

        <div class="row button-sticky">
            <div class="col-12 col-lg-6">
                <app-button (onClick)="resetForm()" class="add-button"
                    [phantom]="true">
                    Limpar filtros
                </app-button>
            </div>

            <div class="col-12 col-lg-6">
                <div class="text-right">
                    <app-button (onClick)="filterData(activedTab)"
                        [loading]="loading"
                        [disabled]="loading || !canApplyFilters">
                        Aplicar filtros
                    </app-button>
                </div>
            </div>
        </div>
    </form>

    <form [formGroup]="fsFilterForm" *ngIf="activedTab === 'fundo'">
        <div class="row">
            <div class="col-12">
                <app-input [group]="fsFilterForm" controlName="search"
                    placeholder="Digite" label="Nome">
                </app-input>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12">
                <app-select [items]="statusOptions" [group]="fsFilterForm"
                    controlName="status" placeholder="Selecione" label="Status">
                </app-select>
                <app-spacer [bottom]="16"></app-spacer>
            </div>


        </div>
        <app-spacer [bottom]="32"></app-spacer>

        <div class="row button-sticky">
            <div class="col-12 col-lg-6">
                <app-button (onClick)="resetForm()" class="add-button"
                    [phantom]="true">
                    Limpar filtros
                </app-button>
            </div>

            <div class="col-12 col-lg-6">
                <div class="text-right">
                    <app-button (onClick)="filterData(activedTab)"
                        [loading]="loading"
                        [disabled]="loading || !canApplyFilters">
                        Aplicar filtros
                    </app-button>
                </div>
            </div>
        </div>
    </form>
</app-side-modal>